import * as React from 'react';

function BackToTop() {
  return (
    <div className="sticky inset-x-0 bottom-0 z-30 hidden w-full mx-auto pointer-events-none sm:block max-w-7xl md:justify-end md:flex md:fixed">
      <a
        href="#top"
        className="pointer-events-auto group focus:outline-none focus:shadow-outline-primary bg-primary"
      >
        <span className="flex items-center justify-center bg-primary group-focus:bg-primary-light">
          <h3 className="px-12 py-4 text-sm font-bold tracking-wider text-white uppercase whitespace-no-wrap">
            Back to top
          </h3>
        </span>
      </a>
    </div>
  );
}

export { BackToTop };
